export const throttle = 150;

export const gtmConfig = {
  containerId: process.env.REACT_APP_GTM_CONTAINER_ID
};

export const amplifyConfig = {
  aws_project_region: 'ap-south-1',
  aws_cognito_identity_pool_id: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
  aws_cognito_region: 'ap-south-1',
  aws_user_pools_id: 'ap-south-1_Mk6C4Vwzb',
  aws_user_pools_web_client_id: '2snc8m3f25crp1fo1917f83vtm'
};

export const amplifyTechnicianConfig = {
  aws_project_region: process.env.REACT_APP_AWS_PROJECT_REGION,
  aws_cognito_identity_pool_id: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
  aws_cognito_region: process.env.REACT_APP_AWS_COGNITO_REGION,
  aws_user_pools_id: 'ap-south-1_DS4Np65z0',
  aws_user_pools_web_client_id: '3rbhi94fm70kgehcfc0k88io3m'
};

export const auth0Config = {
  client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN
};

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
};

export const APIConfig = {
  apiUrl: 'https://api.servcare.com/api/',
  channelPartnerApiUrl: 'https://api.servcare.com/api/',
  userManagementApiUrl: 'https://api.servcare.com/api/',
  requestManagementUrl: 'https://api.servcare.com/api/',
};

export const ConstantConfig = {
  eWasteServiceId: 'SID102',
  ucoWasteServiceId: 'SID104',
  plasticWasteServiceId: 'SID103',
  textileWasteServiceId: 'SID105',
  plasticCategoryId: 'CID109',
  textileCategoryId: 'CID111',
  ucoCategoryId: 'CID110',
  ewasteCategoryIds: 'CID101,CID102,CID103,CID104,CID107,CID108'.split(',')
};
